import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import ReportRevenue from '@/components/ReportRevenue.vue'
import ReportRevenue2 from '@/components/ReportRevenue2.vue'
import ReportCollection from '@/components/ReportCollection.vue'
import ReportCollection2 from '@/components/ReportCollection2.vue'
import ReportFinance from '@/components/ReportFinance.vue'
import ReportTotal from '@/components/ReportTotal.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: ReportFinance
    },
    {
      path: '/report-revenue',
      name: 'report-revenue',
      component: ReportRevenue,
    },
    {
      path: '/report-revenue2',
      name: 'report-revenue2',
      component: ReportRevenue2,
    },
    {
      path: '/report-collection',
      name: 'report-collection',
      component: ReportCollection,
    },
    {
      path: '/report-collection2',
      name: 'report-collection2',
      component: ReportCollection2,
    },
    {
      path: '/report-finance',
      name: 'report-finance',
      component: ReportFinance,
    },
    {
      path: '/report-total',
      name: 'report-total',
      component: ReportTotal,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
